export default __webpack_public_path__ + "static/anny.franzelin-27b763c6c869c862d56c25ed01920195.jpg";